export default __webpack_public_path__ + "static/media/foliage.e6e0418f.jpg";